module.exports = __webpack_public_path__ + "static/img/redeem.a55d8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/redeem.png
// module id = ro8D
// module chunks = 1